module.exports = __webpack_public_path__ + "static/media/sn.5a3a015c.svg";